export default __webpack_public_path__ + "static/media/vhomeimage3.c8ffa9c4.jpg";